module.exports = __webpack_public_path__ + "assets/img/carTicket.205988b8.png";